import React from "react";
import { Container, Typography } from "@mui/material";
import SignupForm from "@components/auth/SignupForm";
import FreeReportForm from "@components/campaigns/FreeReportForm";
import {
  PortraitLogoContainer,
  ContentArea,
  HeaderContainer,
  HeroSection,
  PageWrapper,
  FormContainer,
  InfoBlock,
  AdditionalContent,
  FormContainerStyled,
} from "@components/campaigns/free-report.styles";
// import CursorBug from "@components/campaigns/CursorBug";
import AnimatedBackground from "@components/campaigns/AnimatedBackground";
import Footer from "@components/page/footer/Footer";
import { FooterContainer } from "@helpers/style/global.styles";
import {
  BackgroundComponent,
  PersonContainer,
} from "@components/campaigns/Page.styles";

interface Props {
  inviteToken?: string;
}

export function SignupPage({ inviteToken }: Props) {
  return (
    <PageWrapper>
      {/* <CursorBug
        imagePath="/assets/eyeroll-images/bug.gif"
        size={75}
        ease={0.075}
      /> */}

      <HeroSection>
        <BackgroundComponent />

        <ContentArea>
          <HeaderContainer>
            <a className="navbar-brand" href="/">
              <PortraitLogoContainer>
                <img
                  src="/assets/images/logo.svg"
                  alt="Autonomous QA for web, mobile and desktop apps"
                />
              </PortraitLogoContainer>
            </a>
            <div id="HeaderTitle">
              <Typography variant="h1" color="secondary.main">
                Welcome to your <span>best app</span> yet
              </Typography>
              <Typography variant="handwritten">
                Get your testing sorted today!
              </Typography>
            </div>
          </HeaderContainer>

          <PersonContainer>
            <AnimatedBackground
              width="400px"
              height="700px"
              eyesLeftMargin={29.0}
              eyesTopMargin={34.5}
              eyeSizePercent={6.5}
              eyeSpacingPercent={6.0}
              pupilSizeRatio={0.75} // Pupils are 40% of eye size
              pupilXOffset={0.5} // Pupils positioned slightly left of center
              pupilYOffset={0.5} // Pupils centered vertically
              backgroundImagePath="/assets/eyeroll-images/person.png"
              eyeImagePath="/assets/eyeroll-images/eye.png"
              pupilImagePath="/assets/eyeroll-images/pupil.png"
            />
          </PersonContainer>
          <FormContainer>
            {inviteToken ? (
              <Container maxWidth="md" sx={{ padding: 0 }}>
                <FormContainerStyled id="FreeReportForm" elevation={0}>
                  <SignupForm inviteToken={inviteToken} />
                </FormContainerStyled>
              </Container>
            ) : (
              <FreeReportForm isFree={false} />
            )}
          </FormContainer>
        </ContentArea>
      </HeroSection>

      <AdditionalContent>
        <InfoBlock>
          <div className="info left">
            <Typography variant="h3">QA that actually catches bugs</Typography>
            <Typography variant="body1">
              TestTheTest goes beyond checklists and snapshots.{" "}
              <strong>We test your app the way real users do</strong> —
              clicking, swiping, mistyping passwords — and find what your unit
              tests don&apos;t.
              <br />
              <br />
              It&apos;s as thorough as a human. As fast as a bot. And built to
              run quietly in the background while you build.
            </Typography>
          </div>

          <div className="info right">
            <Typography variant="h3">
              One form. One report. Zero nonsense.
            </Typography>
            <Typography variant="body1">
              Tell us where to find your app — and we&apos;ll send back a full
              QA report within a few days. No meetings. No integration. No fine
              print.
              <br />
              <br />
              We&apos;ll test your product like a user would, catch the bugs you
              didn&apos;t see coming, and if you like what you see, we&apos;ll
              talk.
            </Typography>
          </div>
        </InfoBlock>
      </AdditionalContent>

      <FooterContainer>
        <Footer />
      </FooterContainer>
    </PageWrapper>
  );
}
